import api from "./axiosInstance";

/**
 * @param {number} limit
 * @param {number} offset
 */
export const getResidencies = async (limit = 10, offset = 0) => {
  const response = await api.get(
    `api/v1/residencies/?limit=${limit}&offset=${offset}`
  );
  return response.data;

};

export const createResidency = async (payload) => {
  const response = await api.post(
    "api/v1/residencies/",
    payload
  );
  return response.data;
};

export const updateResidency = async (id, payload) => {
  const response = await api.patch(
    `api/v1/residencies/${id}`,
    payload
  );
  return response.data;
};



export const deleteResidency = async (linkId) => {
  await api.delete(`api/v1/residencies/${linkId}/`);
};

